import AddDomainModal from "@/components/AddDomainModal";
import DomainsTable from "@/components/DomainsTable";
import { CompanySchema } from "@/schemas/company.schema";
import { DomainSchema } from "@/schemas/domain.schema";
import { getCompanyById, getCompanyDomains } from "@/services/companies.service";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { z } from "zod";

export default function CompanyDetailsPage() {
    const [company, setCompany] = useState<z.infer<typeof CompanySchema> | null>(null);
    const [domains, setDomains] = useState<z.infer<typeof DomainSchema>[]>([]);

    const params = useParams();
    const company_id = params?.company_id as string;

    const getCompanyDetails = useCallback(async () => {
        const result = await getCompanyById(company_id as string);
        setCompany(() => result);
    }, [company_id]);

    const getCompanyDomainsHandler = useCallback(async () => {
        const domains = await getCompanyDomains(company_id as string);
        setDomains(() => domains);
    }, [company_id]);

    useEffect(() => {
        getCompanyDetails();
        getCompanyDomainsHandler();
    }, [company_id, getCompanyDetails, getCompanyDomainsHandler]);

    return (
        <div>
            <div className="flex items-center justify-between">
                Company name: {company?.Name}

                <AddDomainModal companyId={company_id as string} onAddSuccess={getCompanyDomainsHandler} />
            </div>

            <DomainsTable domains={domains} />
        </div>
    )
}